import { useDispatch } from "react-redux"
import { useCallback } from "react";
import { setPreviousRandomAlbumAsPointed } from "../../actions/randomModeActions";

export const usePreviousAlbum = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(setPreviousRandomAlbumAsPointed())
    }, [dispatch])
}